import { create } from "zustand";
import { SignupExpertParams } from "@src/api/expert/expertApi";

export type OfficeInfo = {
    id?: string;
    name?: string;
    ceo?: string;
    address?: string;
    phone?: string;
    registrationNumber?: string;
    pnu?: string;
};

type AgreementTerm = {
    isChecked: boolean;
    isRequire: boolean;
    title: string;
    link: string;
};

export type SignupExpertState = {
    form: SignupExpertParams;
    validationErrors: Record<string, string>;
    isPartnerCodeValid: boolean | null;
    isAgreementTermsChecked: boolean;
    reset: () => void;
    setPartialState: (partial: Partial<SignupExpertState>) => void;
};

const initialForm: SignupExpertParams = {
    phone: "",
    email: "",
    name: "",
    osType: "",
    isAgreedMarketing: false,
    isAuctionAgent: false,
    bankName: "",
    bankAccount: "",
    counselingCategories: [],
};

export const termList: AgreementTerm[] = [
    { isChecked: false, isRequire: true, title: "서비스 이용약관", link: "serviceTerm" },
    { isChecked: false, isRequire: true, title: "개인정보 수집 및 이용", link: "collectionConsentTerm" },
    { isChecked: false, isRequire: true, title: "위치기반 서비스 이용약관", link: "LocationServiceTerm" },
    { isChecked: false, isRequire: false, title: "매물정보 및 광고성 정보 수신", link: "marketingTerm" },
];

export const useSignupExpertStore = create<SignupExpertState>((set) => ({
    form: initialForm,
    validationErrors: {},
    isPartnerCodeValid: null,
    isAgreementTermsChecked: false,

setPartialState: (partial) =>
    set((state) => ({ ...state, ...partial })),
    reset: () =>
        set({
            form: initialForm,
            isPartnerCodeValid: null,
            isAgreementTermsChecked: false,
        }),
}));
